export class FormSelectAction
{
	selects = document.querySelectorAll('[data-s~="FormSelectAction:select"]')

    change(e)
    {
		let uuid = e.getAttribute("data-uuid")

		let form = document.querySelector('[data-s~="FormSelectAction:form"][data-uuid~="'+uuid+'"]')

        form.action = e.options[e.selectedIndex].value
    }

	watch()
	{
        this.selects.forEach(e => {
            e.addEventListener("change", () => {
                this.change(e)
            })
        })
	}
}
